import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export async function fetchCollection(path) {
  const { data } = await api.get(path);
  return data;
}

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || "No se ha podido completar la acción";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || JSON.stringify(item)).join(" ");
  }
  return detail?.msg || String(detail);
}
